/**
 * Render an upstream search highlight safely.
 *
 * The snippets are the DRep's own metadata prose with `<em>` inserted around
 * the match, so they are attacker-controlled text carrying markup we want to
 * keep. Everything is escaped and only `<em>` is restored — the existing
 * navbar card injects these snippets raw, which lets a DRep put script into
 * anyone's search results.
 */
export function sanitizeHighlight(snippet: string): string {
  const escaped = snippet
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  return escaped.replace(/&lt;(\/?)em&gt;/g, '<$1em>');
}
